// removed by extract-text-webpack-plugin
module.exports = {"cta":"cta__2wLYcBptt6ak"};